function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M71.958 54.336c0 4.928 6.23 8.923 13.912 8.923 7.684 0 13.913-3.995 13.913-8.923s-6.229-8.923-13.913-8.923c-7.683 0-13.912 3.995-13.912 8.923",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M74.686 55.895c0 4.928 6.229 8.923 13.913 8.923s13.912-3.995 13.912-8.923-6.228-8.923-13.912-8.923c-7.684 0-13.913 3.995-13.913 8.923z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M74.686 55.895v8.252c0 4.928 6.229 8.923 13.913 8.923s13.912-3.995 13.912-8.923v-8.252",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  fill: "#FFC5C5",
  d: "M76.862 155.05l-1.397-10.186 11.584-5.991 14.978 3.994 1.198 9.388-10.584 7.82z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M79.192 155.583l-.597-10.186 10.784-5.992 14.979 3.995 1.198 9.387-10.585 8.237z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M105.559 152.652v7.725l-10.39 8.237-15.777-5.44-.2-7.59m15.778 5.44l.2 7.59"
}), React.createElement("path", {
  d: "M95.57 88.096s-16.947 12.241-16.333 12.241l18.937 14.365-2.605-26.606z",
  fill: "#DFC0FF"
}), React.createElement("path", {
  d: "M97.843 89.802s-16.947 12.24-16.332 12.24l18.936 14.365-2.604-26.605z",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M100.447 116.407v8.056L81.51 110.097v-8.054 5.733"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M190.567 256.375H51.376v-229h179v188.606M121.375 60.709h80m-80 46.25h80m-80 46.25h80m-79.987 53.583h82"
}), React.createElement("path", {
  fill: "#EBFFC0",
  d: "M248.911 261.366h9.25v-9.25h-9.25z"
}), React.createElement("path", {
  fill: "#DFC0FF",
  d: "M226.857 289.605l7.793-11.226 7.793 11.226z"
}), React.createElement("path", {
  d: "M210.092 268.754a5.305 5.305 0 1 0 10.61-.002 5.305 5.305 0 0 0-10.61.002",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M189.366 269.44c0 30.538 24.757 55.295 55.296 55.295 30.538 0 55.295-24.757 55.295-55.296 0-30.539-24.757-55.295-55.295-55.295-30.539 0-55.296 24.756-55.296 55.295z",
  stroke: "#2E388E",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M198.766 269.787c.072-1.336.202-2.657.387-3.961 3.156-22.29 22.362-39.488 45.509-39.488m-44.862 59.5a45.879 45.879 0 0 1-1.803-9.922m46.665 42.35c-13.413 0-25.502-5.774-33.913-14.968m67.354 9.878l27.183 27.182.004-.005c.035.035.064.073.098.108a7.544 7.544 0 0 0 10.669-10.67c-.034-.034-.072-.063-.107-.097l.005-.005-27.182-27.182m-77.669-33.067a5.779 5.779 0 1 0 11.558 0 5.779 5.779 0 0 0-11.558 0zm0 0h-16.578m99.363 0h-9.711m-63.344 4.214l10.662 10.795m8.25-.917l12.252-22.412",
  stroke: "#2E388E",
  strokeWidth: 0.75
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M228.217 289.605l7.793-11.226 7.794 11.226z"
}), React.createElement("path", {
  stroke: "#2E388E",
  strokeWidth: 0.75,
  d: "M250.206 261.366h9.25v-9.25h-9.25z"
}), React.createElement("path", {
  fill: "#FFC5C5",
  d: "M270.208 273.197l-.69-6.859 5.733-2.966 7.415 1.978.594 8.083-5.24 3.764z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M271.363 275.081l-.296-8.479 5.337-2.966 7.416 1.977.594 8.084-5.24 4.077z"
}), React.createElement("path", {
  d: "M259.45 258.75l12.104 7.365",
  stroke: "#2E388E",
  strokeWidth: 0.75
}), React.createElement("path", {
  fill: "#EBFFC0",
  d: "M74.627 201.284l14.102 10.929 16.856-12.338-14.079-11.048z"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M77.349 201.284l14.102 10.929 16.856-12.338-14.08-11.048zm31.354-1.308l.021 9.016c-.098.043-17.056 12.385-17.056 12.385"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M76.968 201.135v8.798l14.482 11.079v-8.871"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 370 370",
    width: "1em",
    height: "1em"
  }, props), _ref);
};

export default SvgComponent;


// WEBPACK FOOTER //
// ./src/components/sections/ourVirtualExperts/steps/slides/slide_6.svg